import React from 'react';
import Combobox from "../Combobox";

const Holders = (props) => {

  const items = () => {
    if (props.items == null) {
      return [{
        id: props.value,
        description: props.name
      }]
    }

    return props.items;
  }

  const isDisabled = props.disabled || !props.items;

  return (
    <Combobox
      emptyLabel={'Account holder'}
      {...props}
      disabled={isDisabled}
      items={items()}
    />
  )
}

export default Holders;